import React from 'react';
import ReactDOM from 'react-dom/client';
import "amfe-flexible";
import "intersection-observer"
import App from '@/App';
import '@/styles'
import { HashRouter, BrowserRouter } from 'react-router-dom'
import ArticlesApp from '@/ArticlesApp'
import CloudstoreApiApp from '@/pages/cloudstore-api'

// 按当前 pathname 分流（共用同一个 bundle，各自有独立 index.html）：
//   /articles*        → 文章站（BrowserRouter，真实路径 域名/articles/xxx）
//   /cloudstore-api*  → API 控制台（HashRouter，域名/cloudstore-api/#/dashboard）
//   其余（/）         → 主站（HashRouter，域名/#/xxx）
const pathname = window.location.pathname;
const isArticles = pathname.startsWith('/articles');
const isCloudstoreApi = pathname.startsWith('/cloudstore-api');

const container = document.getElementById('root') as HTMLElement;

if (isArticles) {
  const tree = (
    <React.StrictMode>
      <BrowserRouter>
        <ArticlesApp />
      </BrowserRouter>
    </React.StrictMode>
  );
  // 文章页在构建时会被预渲染成静态 HTML（见 scripts/prerender-articles.js）。
  // 生产环境下 #root 已有内容 → hydrate 接管；预渲染阶段（空壳）或其它情况 → 正常渲染。
  if (container.hasChildNodes()) {
    ReactDOM.hydrateRoot(container, tree);
  } else {
    ReactDOM.createRoot(container).render(tree);
  }
} else {
  // 主站与 cloudstore-api 共用一个 HashRouter，按 pathname 决定挂载哪个 app。
  // 路由形如 域名/cloudstore-api/#/dashboard、域名/#/xxx。
  ReactDOM.createRoot(container).render(
    <React.StrictMode>
      <HashRouter>
        {isCloudstoreApi ? <CloudstoreApiApp /> : <App />}
      </HashRouter>
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
